import { City, Country } from "country-state-city";
import { transliterate } from "transliteration";
import countries from "world-countries";

const countryNamesByCode = new Map(
  Country.getAllCountries().map((country) => [country.isoCode, country.name])
);
const worldCountryMetaByCode = new Map(
  countries.map((country) => [country.cca2, { name: country.name.common, region: country.region, subregion: country.subregion }])
);

function normalizeSearchText(text) {
  return transliterate(String(text || "")).toLowerCase().trim();
}

const citySeen = new Set();
const ALL_BIRTHPLACE_CITIES = City.getAllCities()
  .map((city) => {
    const countryMeta = worldCountryMetaByCode.get(city.countryCode);
    const countryName = countryMeta?.name || countryNamesByCode.get(city.countryCode) || city.countryCode;
    const label = `${city.name}, ${countryName}`;
    const dedupeKey = `${city.name.toLowerCase()}|${city.countryCode}`;
    if (citySeen.has(dedupeKey)) return null;
    citySeen.add(dedupeKey);
    return {
      name: label,
      nameSearch: normalizeSearchText(label),
      countryCode: city.countryCode,
    };
  })
  .filter(Boolean);

function sortByLocalePreference(cities, locale) {
  return [...cities].sort((a, b) => {
    if (locale === "vi") {
      const aIsVietnam = a.countryCode === "VN" ? 0 : 1;
      const bIsVietnam = b.countryCode === "VN" ? 0 : 1;
      if (aIsVietnam !== bIsVietnam) return aIsVietnam - bIsVietnam;
    }
    return a.name.localeCompare(b.name);
  });
}

const SORTED_CITY_CACHE = {
  en: sortByLocalePreference(ALL_BIRTHPLACE_CITIES, "en"),
  vi: sortByLocalePreference(ALL_BIRTHPLACE_CITIES, "vi"),
};

export function getBirthplaceCityOptions({ locale = "en", query = "", limit = 200 }) {
  const normalizedQuery = normalizeSearchText(query);
  const cacheLocale = locale === "vi" ? "vi" : "en";
  const localeSorted = SORTED_CITY_CACHE[cacheLocale] || [];

  if (!normalizedQuery) {
    return localeSorted
      .slice(0, limit)
      .map(({ name, group, countryCode }) => ({ name, group, countryCode }));
  }

  const startsWithMatches = [];
  const containsMatches = [];

  for (const city of localeSorted) {
    if (!city.nameSearch.includes(normalizedQuery)) continue;
    if (city.nameSearch.startsWith(normalizedQuery)) startsWithMatches.push(city);
    else containsMatches.push(city);
    if ((startsWithMatches.length + containsMatches.length) >= limit) break;
  }

  return [...startsWithMatches, ...containsMatches]
    .slice(0, limit)
    .map(({ name, countryCode }) => ({ name, countryCode }));
}
